import {ErrorMessages} from 'constants/Errors';
import {SuccessMessages} from 'constants/Success';

import {call, put, select} from 'redux-saga/effects';
import {deleteSingleEditor} from 'services/page-editors';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import {getPageEditorsACS} from 'store/pageEditors/requestAC';
import {GetPageEditorsDTO} from 'typescript/dto/pageEditorsDto';

import {deleteEditorACS} from '../requestAC';

export function* deleteEditorSaga(action: ReturnType<typeof deleteEditorACS>) {
  const filters: GetPageEditorsDTO = yield select((state) => state.pageEditors.filters);

  try {
    yield call(deleteSingleEditor, action.payload);
    yield put(getPageEditorsACS(filters));
    yield put(setSuccessAC(SuccessMessages.DELETE_EDITOR));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.PAGE_EDITOR_DELETE);
  }
}
